export default __webpack_public_path__ + "c925316de230fb60cdd10f829c12ed10.jpg";